import { 
  Injectable, 
  // NgZone 
} from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InitService {

  constructor(
    // protected zone: NgZone,
  ) {
  }










  needScript(url): boolean {
    let scripts = document.head.getElementsByTagName('script');
    for(let i = scripts.length; i--;){
      if(scripts[i].src == url) return false;
    }
    return true;
  }
  
  
  
  
  
  
  
  
  
  
  loadScript(url) {
    if(this.needScript(url)){
      let node = document.createElement('script');
      // = 'cross-site-cookie=bar; SameSite=None; Secure';
      node.setAttribute("SameSite", "Secure")
      // node.crossOrigin = "anonymous";
      node.type = 'text/javascript';
      node.charset = 'utf-8';
      // node.onload = () => {
      //   this.zone.run(() => {
      //     onReady((window as any)[globalVar]);
      //   });
      // };
      node.src = url;
      node.async = true;
      node.defer = true;
      document.head.appendChild(node);
      // document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
  
  
  
  
  
  
  
  
  
  
  loadPayPal() {
    let url = `https://www.paypal.com/sdk/js?client-id=${environment.paypal}`;
    this.loadScript(url);
  }
  
}